import type { CustomerRow } from "@/lib/types";

/** The status filter on the Customers list. */
export type StatusFilter =
  "all" | "signed_up" | "earning" | "paid" | "reversed";

export const STATUS_FILTERS: ReadonlyArray<{
  value: StatusFilter;
  label: string;
}> = [
  { value: "all", label: "All" },
  { value: "signed_up", label: "Signed up" },
  { value: "earning", label: "Earning" },
  { value: "paid", label: "Paid" },
  { value: "reversed", label: "Reversed" },
];

/**
 * The referral statuses each filter keeps. `all` keeps every row, including
 * statuses no group names (`not_eligible`).
 */
const GROUPS: Record<Exclude<StatusFilter, "all">, readonly string[]> = {
  signed_up: ["signed_up"],
  earning: ["pending", "on_hold", "payable"],
  paid: ["paid"],
  reversed: ["reversed", "rejected", "voided"],
};

export function matchesStatus(status: string, filter: StatusFilter): boolean {
  return filter === "all" || GROUPS[filter].includes(status);
}

/** Case-insensitive match on the masked name or the first order's product. */
export function matchesSearch(row: CustomerRow, search: string): boolean {
  const q = search.trim().toLowerCase();
  if (q === "") return true;
  return (
    row.name.toLowerCase().includes(q) ||
    (row.product ?? "").toLowerCase().includes(q)
  );
}

export function filterCustomers(
  rows: readonly CustomerRow[],
  { search, status }: { search: string; status: StatusFilter },
): CustomerRow[] {
  return rows.filter(
    (r) => matchesStatus(r.status, status) && matchesSearch(r, search),
  );
}
